import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Subscription } from 'rxjs';

import { SystemCodeService } from '../service/system-code.service';
import { SystemCodeMap } from '../shared/configs/system-code-map';

@Injectable({
  providedIn: 'root'
})
export class CapaManagementSystemCodeService {
  systemCodeServiceSubscription: Subscription;
  findingLevelList$ = new BehaviorSubject<any[]>([]);
  mainProcessList$ = new BehaviorSubject<any[]>([]);
  capaSourceList$ = new BehaviorSubject<any[]>([]);
  capaStatusList$ = new BehaviorSubject<any[]>([]);
  findingStatusList$ = new BehaviorSubject<any[]>([]);
  completionStatusList$ = new BehaviorSubject<any[]>([]);
  constructor(
    private http: HttpClient,
    private systemCodeService: SystemCodeService,
  ) {}

  loadSystemCode() {
    if (this.systemCodeServiceSubscription) {
      this.systemCodeServiceSubscription.unsubscribe();
    }
    this.systemCodeServiceSubscription = this.getSystemCodeServiceSubscription();
  }

  unsubscribeSystemCode() {
    if (this.systemCodeServiceSubscription) {
      this.systemCodeServiceSubscription.unsubscribe();
    }
  }

  private getSystemCodeServiceSubscription() {
    const {
      capaSourceCategoryList,
      capaTaskStatusList,
      findingLevelList,
      mainProcess,
      taskTypeList,
      parallelSignActionList,
      completionStatusList
    } = SystemCodeMap;

    return this.systemCodeService
      .loadCodes([
        capaSourceCategoryList,
        capaTaskStatusList,
        findingLevelList,
        mainProcess,
        taskTypeList,
        parallelSignActionList,
        completionStatusList
      ])
      .subscribe(data => {
        this.findingLevelList$.next(data[findingLevelList] && data[findingLevelList].childCodes ? data[findingLevelList].childCodes : []);
        this.mainProcessList$.next(data[mainProcess] && data[mainProcess].childCodes ? data[mainProcess].childCodes : []);
        const availableStatus = ['_SYS_PL1_8', '_SYS_PL1_1', '_SYS_PL1_J', '_SYS_PL1_7'];
        const allStatus = data[capaTaskStatusList] && data[capaTaskStatusList].childCodes ? data[capaTaskStatusList].childCodes : [];
        this.capaStatusList$.next(allStatus.filter((c: any) => availableStatus.includes(c.code)));
        this.capaSourceList$.next(data[capaSourceCategoryList] && data[capaSourceCategoryList].childCodes ? data[capaSourceCategoryList].childCodes : []);
        const findingAvailableStatus = ['_SYS_PL1_1', '_SYS_PL1_I', '_SYS_PL1_E', '_SYS_PL1_5', '_SYS_PL1_7'];
        this.findingStatusList$.next(allStatus.filter((c: any) => findingAvailableStatus.includes(c.code)));
        const completionStatusData = data[completionStatusList];
        const completionStatusOptions = completionStatusData &&completionStatusData.childCodes ? completionStatusData.childCodes : [];
        this.completionStatusList$.next(completionStatusOptions);
      });
  }
}
